import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.9755 4.04944c2.2579 0 4.2946.92212 5.7709 2.40349l2.2042-2.20411v5.98128h-5.9814l2.3696-2.36957c-1.1175-1.1205-2.6596-1.81732-4.3633-1.81732-2.71055 0-5.01336 1.75551-5.84476 4.18689H4.05523c.89221-3.54889 4.0942-6.18066 7.92027-6.18066zM7.61072 16.5887c1.1175 1.1205 2.65968 1.8163 4.36438 1.8163 2.7095 0 5.0123-1.7555 5.8447-4.1869h2.0745c-.8912 3.5489-4.0932 6.1806-7.9192 6.1806-2.25797 0-4.2946-.9221-5.77099-2.4034L4 20.1994v-5.9813h5.98131l-2.37059 2.3706z",
    fill: "currentColor"
  }));
});